import styled from 'styled-components';
import { COLORS, FONTS, breakPoint } from '@stelecom/ui-react/assets/js/constants';
import Input from '@stelecom/ui-react/components/input';
import StyledButton from '@stelecom/ui-react/components/buttons/styledButton';

export const breakPoints = {
    desktop: '1750px',
    laptop: '1187px',
    tablet: '980px',
    mobile: '640px',
};


export const Container = styled.div`
  //min-height: 136px;
  padding: 40px 0 40px 0;
  background: ${COLORS.greyBlue};
  // box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);
  margin-top: 50px;
  margin-bottom: -50px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media(max-width: 900px) {
    flex-direction: column;
  }
`;

export const MainText = styled.div`
  text-align: right;
  ${FONTS.Medium};
  font-size: 20px;
  line-height: 28px;
  color: ${COLORS.blueDark};
  // margin: 20px 10px 0;
  margin-right: 40px;
  @media(max-width: 900px) {
    margin-right: 0;
    margin-bottom: 20px;
  }
  @media (${breakPoint(768)}) {
    text-align: center;
  }
`;

export const EmailInput = styled(Input)`
  max-width: 240px;
  margin: 0 !important;
  @media(max-width: 900px) {
    max-width: 460px;
  }
  @media(max-width: ${breakPoints.mobile}) {
    max-width: 70%;
  }
`;

export const ButtonBlock = styled.div`
  flex-direction: row;
  align-items: center;
  @media(max-width: ${breakPoints.laptop}) {
    flex-direction: column;
    justify-content: center;
    margin-left: 40px;
  }
  @media(max-width: 900px) {
    margin-left: 0;
    margin-top: 20px;
  }
`;

export const Button = styled(StyledButton)`
    flex: 0 0 auto;
    height: 45px;
    padding: 9px 24px;
    width: 183px;
    margin-left: 40px;
    @media(max-width: ${breakPoints.laptop}) {
        margin-left: 0;
        margin-bottom: 5px;
  }
  @media(max-width: 900px) {
    margin-left: 0;
    margin-bottom: 10px;
  }
`;

export const Policy = styled.div`
    width: 230px;
    text-align: left;
    ${FONTS.XXS};
    font-size: 12px;
    line-height: 17px;
    display: inline;
    margin-left: 20px;
    @media(max-width: ${breakPoints.laptop}) {
        margin-left: 0;
        text-align: center;
  }
    @media(${breakPoint(768)}) {
        text-align: center;
    }
`;

export const PolicyLink = styled.a`
    text-decoration: underline;
    color: ${COLORS.black};
`;
